import * as React from "react";
import {  TextInput, SelectInput, NumberInput, DateTimeInput, required } from "react-admin";
import { Grid } from "@mui/material";
import {
  PromotionAmountTypeEnum,
  PromotionTypeEnum,
  StatusEnum,
} from "../../common/enum";
import Transformer from "../../common/Transformer";
import { PromotionEditComponent } from "./PromotionComponent";
import { Edit, SimpleForm} from "src/enterprise/ra-rbac";

export const PromotionEdit = () => {
  const transform = (data) => {
    Transformer(data, {
      remove: ["id", "createdAt", "updatedAt"],
      update: {
        fromDate:
          typeof data["from_date"] === "string" ||
          typeof data["from_date"] === "undefined"
            ? data["from_date"]
            : (data["from_date"] as Date).toISOString(),
        toDate:
          typeof data["to_date"] === "string" ||
          typeof data["to_date"] === "undefined"
            ? data["to_date"]
            : (data["to_date"] as Date).toISOString(),
      },
    });
    return data;
  };

  return (
    <Edit
      component={PromotionEditComponent}
      mutationMode="pessimistic"
      transform={transform}
    >
      <SimpleForm>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid container item rowSpacing={1} columnSpacing={2}>
            <Grid item sm={12} md={6}>
              <TextInput disabled source="id" />
            </Grid>
          </Grid>
          <Grid item sm={12} md={4}>
            <TextInput source="name" validate={required()} />
          </Grid>
          <Grid item sm={12} md={4}>
            <TextInput source="description" />
          </Grid>
          <Grid item sm={12} md={4}>
            <TextInput source="code" validate={required()} />
          </Grid>
          <Grid item sm={12} md={6}>
            <SelectInput validate={required()} source="status" choices={StatusEnum} />
          </Grid>
          <Grid item sm={12} md={6}>
            <SelectInput
              validate={required()}
              source="type"
              choices={PromotionTypeEnum}
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <NumberInput
              validate={required()}
              source="amount"
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <SelectInput
              validate={required()}
              source="amount_type"
              choices={PromotionAmountTypeEnum}
            />
          </Grid>
          <Grid item sm={12} md={4}>
            <DateTimeInput validate={required()} source="from_date"/>
          </Grid>
          <Grid item sm={12} md={4}>
            <DateTimeInput validate={required()} source="to_date"/>
          </Grid>
          <Grid item sm={12} md={4}>
            <DateTimeInput disabled source="created_at"/>
          </Grid>
        </Grid>
      </SimpleForm>
    </Edit>
  );
};
